import {
	Modal,
	MimaText,
	MimaButton,
	MimaInput,
	MimaTextArea,
	ReceiptCheckBox as RCB,
	MimaDropdown,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import unitOfMeasurement from '../../utils/unitOfMeasurement.json';
import { currencies } from '../../utils/utils';
import { Formik } from 'formik';
import React, { useRef } from 'react';
import { inventoryStore } from '../../stores';

const AddProduct = ({
	closeModal,
	loading,
	selectOneClick,
	selectTwoClick,
	selectThreeClick,
	fileOne,
	fileTwo,
	fileThree,
	validationSchema,
	verifyAccountNumber,
	banks,
	setAccountName,
	accountName,
	onSubmit,
	setLoading,
	onSelect,
	displayInfo,
	setDisplayInfo,
}) => {

	const eurAmount = inventoryStore?.eurPrice;
	const gbpAmount = inventoryStore?.gbpPrice;
	const ref = useRef();

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitleBold" align="center" mb={3}>
				Add Product Type
			</MimaText>
			<Formik
				innerRef={ref}
				initialValues={{
					name: '',
					description: '',
					type: 'Product',
					unitOfMeasurement: '',
					hasImages: false,
					hasSplit: false,
					noVariation: true,
					hasMulticurrency: false,
					lowStockCount: 0,
					costPrice: 0,
					sellingPrice: 0,
					quantity: 0,
					currencyCode: 'NGN',
					sellingPriceUSD: 0,
					sellingPriceGBP: 0,
					sellingPriceEUR: 0,
					sellingPriceNGN: 0,
					splitName: '',
					splitEmail: '',
					splitPhone: '',
					splitType: '',
					bankCode: '',
					bank: '',
					accountNumber: '',
					// splitPaymentTrigger: '',
					productCondition: 'NEW',
					grade: '',
					autoCreateStock: false,
					// splitPercentage: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					values,
					errors,
					touched,
					setFieldValue,
				}) => (
					<div>
						<div className={styles.type}>
							<MimaText variant="small" mb={2} mt={2} >
								Type
							</MimaText>
							<div className="modal__beside">
								<RCB
									title="Product"
									onChange={() => {
										setFieldValue('type', 'Product');
									}}
									checked={values.type === 'Product'}
									value="Product"
									name="type"
								/>
								<RCB
									title="Service"
									checked={values.type === 'Service'}
									onChange={() => setFieldValue('type', 'Service')}
									value="Service"
									name="type"
								/>
							</div>
							{errors.type ? (
								<div className={styles.error}>
									{''}
									{touched.type && errors.type}
									{''}
								</div>
							) : null}
						</div>
						<MimaInput
							type="text"
							labelTitle={`${values.type} Type Name(max 50 characters)`}
							name="name"
							id="name"
							value={values.name}
							onChange={handleChange}
							error={errors.name}
							touched={touched.name}
							onBlur={handleBlur}
						/>
						<MimaTextArea
							type="text"
							labelTitle="Description(max 100 characters - optional"
							name="description"
							id="description"
							value={values.description}
							onChange={handleChange}
							onBlur={handleBlur}
							touched={touched.description}
							error={errors.description}
						/>

						<MimaDropdown
							labelTitle="U.O.M. (Unit Of Measurement)"
							placeholder="Select Unit Of Measurement"
							name="unitOfMeasurement"
							value={values.unitOfMeasurement}
							id="unitOfMeasurement"
							onChange={data => {
								setFieldValue('unitOfMeasurement', data.key);
							}}
							data={
								values.type === 'Product'
									? unitOfMeasurement.product.map(item => ({
										key: item,
										value: item,
									}))
									: unitOfMeasurement.service.map(item => ({
										key: item,
										value: item,
									}))
							}
							touched={touched.unitOfMeasurement}
							error={errors.unitOfMeasurement}
						/>


						<div className={styles.invoice__checks_group}>
							<div className="modal__beside">
								<RCB
									title="Add Image(s) - (Optional)"
									onChange={() => {
										setFieldValue('hasImages', !values.hasImages);
									}}
									checked={values.hasImages}
									value={values.hasImages}
									name="hasImages"
								/>

							</div>
							{errors.hasImages ? (
								<div className={styles.error}>
									{''}
									{touched.hasImages && errors.hasImages}
									{''}
								</div>
							) : null}
						</div>

						{values.hasImages && (
							<>
								<MimaButton
									title={
										fileOne === null ? 'Select Front Image' : 'Front Image Selected'
									}
									variant="outlined"
									width={38}
									onClick={selectOneClick}
									mt={2}
								/>
								{fileOne !== null ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginTop: '2rem',
										}}>
										<img
											className={styles.imageUpload}
											src={fileOne?.source || ''}
											alt="preview"
										/>
									</div>
								) : (
									''
								)}

								<MimaButton
									title={
										fileTwo === null ? 'Select Back Image' : 'Back Image Selected'
									}
									variant="outlined"
									width={38}
									onClick={selectTwoClick}
									mt={2}
								/>
								{fileTwo !== null ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginTop: '2rem',
										}}>
										<img
											className={styles.imageUpload}
											src={fileTwo?.source || ''}
											alt="preview"
										/>
									</div>
								) : (
									''
								)}

								<MimaButton
									title={
										fileThree === null ? 'Select Side Image' : 'Side Image Selected'
									}
									variant="outlined"
									width={38}
									onClick={selectThreeClick}
									mt={2}
									mb={2}
								/>
								{fileThree !== null ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginBottom: '2rem',
										}}>
										<img
											className={styles.imageUpload}
											src={fileThree?.source || ''}
											alt="preview"
										/>
									</div>
								) : (
									''
								)}
							</>
						)}
						{/* Start Of Has Variants */}
						<div className={styles.type}>
							<div className={styles.type_rcb} >
								<RCB
									title={`Does this ${values.type} Type have Multiple Stocks?`}
									onChange={() => {
										setFieldValue('noVariation', !values.noVariation);
									}}
									checked={!values.noVariation}
									value={values.noVariation}
									name="noVariation"
								/>
							</div>
							{errors.noVariation ? (
								<div className={styles.error}>
									{''}
									{touched.noVariation && errors.noVariation}
									{''}
								</div>
							) : null}
						</div>

						<MimaText width={38} color="var(--color-primary)" mb={1}>
							Enabling multiple stocks means creating individual {values.type} stocks {values.type === "Product" ? ("(e.g. different colors, sizes etc)") : ("(e.g. different sessions, number of hours etc.)")} and setting their prices {values.type === "Product" ? ("and quantities") : (null)} using the "Add Stock" feature.
						</MimaText>

						{values.noVariation && (
							<>
								{values.type === "Product" && (
									<div className={styles.type}>
										<MimaText variant="small" mb={1} mt={3}>
											Condition of Stock
										</MimaText>
										<div className="modal__beside">
											<RCB
												title="Brand New"
												onChange={() => {
													setFieldValue('productCondition', 'NEW');
												}}
												checked={values.productCondition === 'NEW'}
												value={'NEW'}
												name="productCondition"
											/>
											<RCB
												title="Fairly Used"
												onChange={() => {
													setFieldValue('productCondition', 'USED');
												}}
												checked={values.productCondition === 'USED'}
												value={'USED'}
												name="productCondition"
											/>
										</div>
										{errors.productCondition ? (
											<div className={styles.error}>
												{''}
												{touched.productCondition && errors.productCondition}
												{''}
											</div>
										) : null}
									</div>
								)}

								<div className="modal__beside">

									<MimaDropdown
										labelTitle="Select Currency"
										name="currencyCode"
										value={values.currencyCode}
										placeholder={values.currencyCode}
										id="currencyCode"
										currentValue={values.currencyCode}
										onChange={(data) => {
											setFieldValue('currencyCode', data.key);
										}}
										data={currencies}
										touched={touched.currencyCode}
										error={errors.currencyCode}
										width={values.type === 'Product' && 18}
									/>
									{values.type === 'Product' ? (<MimaInput
										type="number"
										labelTitle="Available Quantity"
										name="quantity"
										id="quantity"
										value={values.quantity}
										onChange={handleChange}
										error={errors.quantity}
										touched={touched.quantity}
										onBlur={handleBlur}
										width={18}
									/>) : ""}
								</div>

								<div className="modal__beside">
									{values.type === 'Product' ? (<MimaInput
										type="number"
										labelTitle="Cost Price"
										name="costPrice"
										id="costPrice"
										value={values.costPrice}
										onChange={handleChange}
										error={errors.costPrice}
										touched={touched.costPrice}
										onBlur={handleBlur}
										width={18}
									/>) : ""}
									<MimaInput
										type="number"
										labelTitle="Selling Price"
										name="sellingPrice"
										id="sellingPrice"
										value={values.sellingPrice}
										onChange={handleChange}
										error={errors.sellingPrice}
										touched={touched.sellingPrice}
										onBlur={handleBlur}
										width={values.type === 'Product' && 18}
									/>
								</div>

								{values.type === 'Product' ? (<MimaInput
									type="number"
									labelTitle="Enter Low Stock Quantity"
									name="lowStockCount"
									mb={4}
									value={values.lowStockCount}
									onChange={handleChange}
									onBlur={handleBlur}
									touched={touched.lowStockCount}
								/>) : ""}

								{/* Multicurrency input start */}

								<div className={styles.type}>
									<RCB
										title="Multicurrency for Product type?"
										onChange={() => {
											setFieldValue('hasMulticurrency', !values.hasMulticurrency);
										}}
										checked={values.hasMulticurrency}
										value={values.hasMulticurrency}
										name="hasMulticurrency"
									/>
									{errors.hasMulticurrency ? (
										<div className={styles.error}>
											{''}
											{touched.hasMulticurrency && errors.hasMulticurrency}
											{''}
										</div>
									) : null}
								</div>

								{values.hasMulticurrency && (
									<>
										<div className={styles.addProduct__beside}>
											<MimaInput
												type="number"
												labelTitle="USD"
												name="sellingPriceUSD"
												id="sellingPriceUSD"
												value={values.sellingPriceUSD}
												onChange={handleChange}
												error={errors.sellingPriceUSD}
												touched={touched.sellingPriceUSD}
												onBlur={(e) => {
													handleBlur(e)
													onSelect(values)
													setFieldValue('sellingPriceEUR', eurAmount);
													setFieldValue('sellingPriceGBP', gbpAmount);
												}}
												width={12}
											/>
											<MimaInput
												type="number"
												labelTitle="GBP"
												name="sellingPriceGBP"
												id="sellingPriceGBP"
												value={values.sellingPriceGBP}
												onChange={handleChange}
												error={errors.sellingPriceGBP}
												touched={touched.sellingPriceGBP}
												onBlur={handleBlur}
												width={12}
											/>

											<MimaInput
												type="number"
												labelTitle="EUR"
												name="sellingPriceEUR"
												id="sellingPriceEUR"
												value={values.sellingPriceEUR}
												onChange={handleChange}
												error={errors.sellingPriceEUR}
												touched={touched.sellingPriceEUR}
												onBlur={handleBlur}
												width={12}
											/>
										</div>
									</>
								)}
								{/* Multicurrency input end */}
							</>
						)}

						{/* End Of Has Variants */}

						{/* Start Of Has split payment */}

						<div className={styles.type}>
							<div className="modal__beside">
								<RCB
									title="Split Payment with vendor?"
									onChange={() => {
										setFieldValue('hasSplit', !values.hasSplit);
									}}
									checked={values.hasSplit}
									value={values.hasSplit}
									name="hasSplit"
								/>
							</div>
							{errors.hasSplit ? (
								<div className={styles.error}>
									{''}
									{touched.hasSplit && errors.hasSplit}
									{''}
								</div>
							) : null}
						</div>
						{values.hasSplit && (
							<>
								<div className={styles.bus__details}>
									<MimaDropdown
										labelTitle="Split Type"
										placeholder="-Select-"
										data={['PROFIT', 'SELLING PRICE'].map(type => {
											return {
												key: type,
												value: type,
											};
										})}
										id="splitType"
										onChange={data => {
											setFieldValue('splitType', data.key);
										}}
										name="splitType"
										onBlur={handleBlur}
										touched={touched.splitType}
										error={errors.splitType}
									/>
									<div className={styles.type}>
										<div className="modal__beside">
											<RCB
												title="Create Stock using existing Rate card?"
												onChange={() => {
													setFieldValue('autoCreateStock', !values.autoCreateStock);
												}}
												checked={values.autoCreateStock}
												value={values.autoCreateStock}
												name="autoCreateStock"
											/>
										</div>
									</div>

									{values.autoCreateStock && (
										<MimaDropdown
											labelTitle="Select Grade"
											placeholder={'-Select-'}
											name="grade"
											value={values.grade}
											currentValue={values.grade}
											id="grade"
											onChange={data => {
												setFieldValue('grade', data.key);
											}}
											data={[
												{
													value: 'STANDARD',
													key: 'STANDARD',
												},
												{
													value: 'BUDDING',
													key: 'BUDDING',
												},
												{
													value: 'PREMIUM',
													key: 'PREMIUM',
												},
												{
													value: 'TOP',
													key: 'TOP',
												},
												{
													value: 'EXCEPTIONAL',
													key: 'EXCEPTIONAL',
												},

											]}
											touched={touched.grade}
											error={errors.grade}
										/>
									)}
									<MimaInput
										type="text"
										labelTitle="Split with (Business or Individual Name)"
										name="splitName"
										id="splitName"
										value={values.splitName}
										onChange={handleChange}
										touched={touched.splitName}
										onBlur={handleBlur}
										error={errors.splitName}
									/>
									<MimaInput
										type="text"
										labelTitle="Business or Individual Email"
										name="splitEmail"
										id="splitEmail"
										value={values.splitEmail}
										onChange={handleChange}
										touched={touched.splitEmail}
										onBlur={handleBlur}
										error={errors.splitEmail}
									/>
									<MimaInput
										type="text"
										labelTitle="Business or Individual Phone"
										name="splitPhone"
										id="splitPhone"
										value={values.splitPhone}
										onChange={handleChange}
										touched={touched.splitPhone}
										onBlur={handleBlur}
										error={errors.splitPhone}
									/>

									<MimaDropdown
										labelTitle="Bank Name"
										placeholder="-Select-"
										data={banks}
										id="bankCode"
										onChange={data => {
											setFieldValue('bankCode', data.id);
											setFieldValue('bank', data.value);
										}}
										name="bankCode"
										onBlur={handleBlur}
										error={errors.bankCode}
										touched={touched.bankCode}
									/>
									<MimaInput
										type="text"
										labelTitle="Account Number"
										name="accountNumber"
										value={values.accountNumber}
										onChange={e => {
											setLoading(true);
											verifyAccountNumber({
												accountNumber: e.target.value,
												beneficiaryBank: values.bankCode,
											}).then(data => {
												setAccountName(data);
												setLoading(false);
											});
											handleChange(e);
										}}
										onBlur={handleBlur}
										error={errors.accountNumber}
										touched={touched.accountNumber}
									/>
									<MimaInput
										type="text"
										disabled={true}
										labelTitle="Account Name"
										name="accountName"
										value={accountName}
										placeholder={accountName}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									{/* <MimaDropdown
										labelTitle="When after sales do you want to trigger Split Payment with the Vendor?"
										placeholder={values.splitPaymentTrigger || '-Select-'}
										name="splitPaymentTrigger"
										value={values.splitPaymentTrigger}
										currentValue={values.splitPaymentTrigger}
										id="splitPaymentTrigger"
										onChange={data => {
											setFieldValue('splitPaymentTrigger', data.key);
										}}
										data={['IMMEDIATELY', 'END OF DAY', 'NEXT DAY', 'WEEKLY', 'MONTHLY'].map(value => {
											return {
												key: value,
												value,
											}
										})}
										touched={touched.splitPaymentTrigger}
										error={errors.splitPaymentTrigger}
									/> */}



								</div>
							</>
						)}

						{/* End Of Has split payment */}

						<MimaButton
							title="Continue"
							type="submit"
							onClick={handleSubmit}
							loading={loading}
							mt={2}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default AddProduct;